<template>
    <el-select :value="value+''" :disabled="disabled ? true : false" filterable @input="$emit('input', $event)" :placeholder="placeholder" clearable>
        <el-option :label="data.dictLabel" v-for="data in dataList" :key="data.dictValue" :value ="data.dictValue">{{data.dictLabel}}</el-option>
    </el-select>
</template>
<script>
import { getDictDataList } from '@/utils'
export default {
  name: 'RenSelect',
  data () {
    return {
      dataList: []
    }
  },
  mounted(){
    this.dataList = this.filterOriginPage(this.dictType)
  },
  methods: {
      filterOriginPage(v){
        return this.originPage == 'put'? getDictDataList(v).filter(item => (item.dictLabel !== '按揭房信用贷' && item.dictLabel !== '企业精英贷' && item.dictLabel !== '经营贷')) : getDictDataList(v)
      }
  },
  props: {
    value: [Number, String],
    dictType: String,
    placeholder: String,
    disabled: [String, Boolean],
    originPage: String,
  }
}
</script>
